import {$CC, EUROPE_COUNTRIES, MapDifficultyLevel} from "../types";

// function print() {
//   const codes: string[] = []
//   for (const name of [
// "Albania","Armenia","Austria","Azerbaijan","Belarus","Belgium","Bosnia and Herzegovina","Bulgaria","Croatia","Cyprus","Czech Republic","Denmark","Estonia","Finland","France","Georgia","Germany","Greece","Hungary","Iceland","Ireland","Italy","Kazakhstan","Latvia","Lithuania","Moldova","Netherlands","Norway","Poland","Portugal","Romania","Russia","Serbia","Slovakia","Slovenia","Spain","Sweden","Switzerland","Turkey","Ukraine", "United Kingdom"
//   ]) {
//     console.log(name);
//     const country = COUNTRIES.find(c => c.name === name);
//     codes.push(`$CC("${country.cc}")`);
//   }
//   console.log(codes.join(", "));
// }
// print();
export class EuropeDifficultyLevel extends MapDifficultyLevel {

  static readonly VALUES = new Array<EuropeDifficultyLevel>(1);
  static readonly MEDIUM = EuropeDifficultyLevel.VALUES[0] = new EuropeDifficultyLevel("medium", "Medium", "Medium desc", EUROPE_COUNTRIES);
}